// extracted by mini-css-extract-plugin
export var benefits_container = "Benefits-module--benefits_container--nZ6GK";
export var benefits_header = "Benefits-module--benefits_header--2-JVl";
export var benefits_image = "Benefits-module--benefits_image--nGDas";